export enum ComoGiftStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
